export const ExampleQueryPath = `%7B"type"%3A"group"%2C"id"%3A"initial-example"%2C"children1"%3A%7B"initial-example-rule-1"%3A%7B"type"%3A"rule"%2C"properties"%3A%7B"value"%3A%5B"Blend"%5D%2C"valueSrc"%3A%5B"value"%5D%2C"valueError"%3A%5Bnull%5D%2C"field"%3A"perception_exact"%2C"operator"%3A"select_equals"%2C"operatorOptions"%3Anull%2C"valueType"%3A%5B"treeselect"%5D%7D%2C"id"%3A"initial-example-rule-1"%2C"path"%3A%5B"initial-example"%2C"initial-example-rule-1"%5D%7D%2C"aa8ba8ab-cdef-4012-b456-71918ff47561"%3A%7B"type"%3A"rule"%2C"id"%3A"aa8ba8ab-cdef-4012-b456-71918ff47561"%2C"properties"%3A%7B"field"%3A"effect_exact"%2C"operator"%3A"select_equals"%2C"value"%3A%5B"Timbral+Emergence"%5D%2C"valueSrc"%3A%5B"value"%5D%2C"operatorOptions"%3Anull%2C"valueError"%3A%5Bnull%5D%2C"valueType"%3A%5B"treeselect"%5D%7D%2C"path"%3A%5B"initial-example"%2C"aa8ba8ab-cdef-4012-b456-71918ff47561"%5D%7D%2C"a8aa9abb-89ab-4cde-b012-31918ff4a9f5"%3A%7B"type"%3A"rule"%2C"id"%3A"a8aa9abb-89ab-4cde-b012-31918ff4a9f5"%2C"properties"%3A%7B"field"%3A"strength_exact"%2C"operator"%3A"between"%2C"value"%3A%5B3%2C5%5D%2C"valueSrc"%3A%5B"value"%2Cnull%5D%2C"operatorOptions"%3Anull%2C"valueError"%3A%5Bnull%2Cnull%2Cnull%5D%2C"valueType"%3A%5B"number"%2C"number"%5D%7D%2C"path"%3A%5B"initial-example"%2C"a8aa9abb-89ab-4cde-b012-31918ff4a9f5"%5D%7D%2C"89b89bb9-4567-489a-bcde-f1918ff4ffc5"%3A%7B"type"%3A"group"%2C"id"%3A"89b89bb9-4567-489a-bcde-f1918ff4ffc5"%2C"properties"%3A%7B"conjunction"%3A"OR"%2C"not"%3Afalse%7D%2C"path"%3A%5B"initial-example"%2C"89b89bb9-4567-489a-bcde-f1918ff4ffc5"%5D%2C"children1"%3A%7B"b9bbabab-0123-4456-b89a-b1918ff4ffc6"%3A%7B"type"%3A"rule"%2C"id"%3A"b9bbabab-0123-4456-b89a-b1918ff4ffc6"%2C"properties"%3A%7B"field"%3A"composer_exact"%2C"operator"%3A"select_equals"%2C"value"%3A%5B"Borodin"%5D%2C"valueSrc"%3A%5B"value"%5D%2C"operatorOptions"%3Anull%2C"valueError"%3A%5Bnull%5D%2C"valueType"%3A%5B"select"%5D%7D%2C"path"%3A%5B"initial-example"%2C"89b89bb9-4567-489a-bcde-f1918ff4ffc5"%2C"b9bbabab-0123-4456-b89a-b1918ff4ffc6"%5D%7D%2C"889aabab-89ab-4cde-b012-31918ff5629b"%3A%7B"type"%3A"rule"%2C"id"%3A"889aabab-89ab-4cde-b012-31918ff5629b"%2C"properties"%3A%7B"field"%3A"composer_exact"%2C"operator"%3A"select_equals"%2C"value"%3A%5B"Debussy"%5D%2C"valueSrc"%3A%5B"value"%5D%2C"operatorOptions"%3Anull%2C"valueError"%3A%5Bnull%5D%2C"valueType"%3A%5B"select"%5D%7D%2C"path"%3A%5B"initial-example"%2C"89b89bb9-4567-489a-bcde-f1918ff4ffc5"%2C"889aabab-89ab-4cde-b012-31918ff5629b"%5D%7D%7D%7D%2C"a9a89b9a-cdef-4012-b456-71918ff50af6"%3A%7B"type"%3A"rule"%2C"id"%3A"a9a89b9a-cdef-4012-b456-71918ff50af6"%2C"properties"%3A%7B"field"%3A"evolution_exact"%2C"operator"%3A"select_equals"%2C"value"%3A%5B"Transforming"%5D%2C"valueSrc"%3A%5B"value"%5D%2C"operatorOptions"%3Anull%2C"valueError"%3A%5Bnull%5D%2C"valueType"%3A%5B"select"%5D%7D%2C"path"%3A%5B"initial-example"%2C"a9a89b9a-cdef-4012-b456-71918ff50af6"%5D%7D%7D%2C"path"%3A%5B"initial-example"%5D%7D`;

export const ExampleQuery = {
    "type": "group",
    "id": "initial-example",
    "children1": {
        "initial-example-rule-1": {
            "type": "rule",
            "properties": {
                "value": [
                    "Blend"
                ],
                "valueSrc": [
                    "value"
                ],
                "valueError": [
                    null
                ],
                "field": "perception_exact",
                "operator": "select_equals",
                "operatorOptions": null,
                "valueType": [
                    "treeselect"
                ]
            },
            "id": "initial-example-rule-1",
            "path": [
                "initial-example",
                "initial-example-rule-1"
            ]
        },
        "aa8ba8ab-cdef-4012-b456-71918ff47561": {
            "type": "rule",
            "id": "aa8ba8ab-cdef-4012-b456-71918ff47561",
            "properties": {
                "field": "effect_exact",
                "operator": "select_equals",
                "value": [
                    "Timbral Emergence"
                ],
                "valueSrc": [
                    "value"
                ],
                "operatorOptions": null,
                "valueError": [
                    null
                ],
                "valueType": [
                    "treeselect"
                ]
            },
            "path": [
                "initial-example",
                "aa8ba8ab-cdef-4012-b456-71918ff47561"
            ]
        },
        "a8aa9abb-89ab-4cde-b012-31918ff4a9f5": {
            "type": "rule",
            "id": "a8aa9abb-89ab-4cde-b012-31918ff4a9f5",
            "properties": {
                "field": "strength_exact",
                "operator": "between",
                "value": [
                    3,
                    5
                ],
                "valueSrc": [
                    "value",
                    null
                ],
                "operatorOptions": null,
                "valueError": [
                    null,
                    null,
                    null
                ],
                "valueType": [
                    "number",
                    "number"
                ]
            },
            "path": [
                "initial-example",
                "a8aa9abb-89ab-4cde-b012-31918ff4a9f5"
            ]
        },
        "89b89bb9-4567-489a-bcde-f1918ff4ffc5": {
            "type": "group",
            "id": "89b89bb9-4567-489a-bcde-f1918ff4ffc5",
            "properties": {
                "conjunction": "OR",
                "not": false
            },
            "path": [
                "initial-example",
                "89b89bb9-4567-489a-bcde-f1918ff4ffc5"
            ],
            "children1": {
                "b9bbabab-0123-4456-b89a-b1918ff4ffc6": {
                    "type": "rule",
                    "id": "b9bbabab-0123-4456-b89a-b1918ff4ffc6",
                    "properties": {
                        "field": "composer_exact",
                        "operator": "select_equals",
                        "value": [
                            "Borodin"
                        ],
                        "valueSrc": [
                            "value"
                        ],
                        "operatorOptions": null,
                        "valueError": [
                            null
                        ],
                        "valueType": [
                            "select"
                        ]
                    },
                    "path": [
                        "initial-example",
                        "89b89bb9-4567-489a-bcde-f1918ff4ffc5",
                        "b9bbabab-0123-4456-b89a-b1918ff4ffc6"
                    ]
                },
                "889aabab-89ab-4cde-b012-31918ff5629b": {
                    "type": "rule",
                    "id": "889aabab-89ab-4cde-b012-31918ff5629b",
                    "properties": {
                        "field": "composer_exact",
                        "operator": "select_equals",
                        "value": [
                            "Debussy"
                        ],
                        "valueSrc": [
                            "value"
                        ],
                        "operatorOptions": null,
                        "valueError": [
                            null
                        ],
                        "valueType": [
                            "select"
                        ]
                    },
                    "path": [
                        "initial-example",
                        "89b89bb9-4567-489a-bcde-f1918ff4ffc5",
                        "889aabab-89ab-4cde-b012-31918ff5629b"
                    ]
                }
            }
        },
        "a9a89b9a-cdef-4012-b456-71918ff50af6": {
            "type": "rule",
            "id": "a9a89b9a-cdef-4012-b456-71918ff50af6",
            "properties": {
                "field": "evolution_exact",
                "operator": "select_equals",
                "value": [
                    "Transforming"
                ],
                "valueSrc": [
                    "value"
                ],
                "operatorOptions": null,
                "valueError": [
                    null
                ],
                "valueType": [
                    "select"
                ]
            },
            "path": [
                "initial-example",
                "a9a89b9a-cdef-4012-b456-71918ff50af6"
            ]
        }
    },
    "path": [
        "initial-example"
    ]
};
